@if (flaggedFilesSummary(); as flaggedSummary) {
  <div class="flagged-files-summary" [dataSelector]="dataSelector">
    <div class="flagged-files-summary__header">
      <aiwyn-icon
        name="flag-pennant"
        namespace="phosphor"
        [width]="16"
        [height]="16"
        class="flagged-files-summary__icon"
        [dataSelector]="dataSelector + '-icon'">
      </aiwyn-icon>

      @if (flaggedSummary.totalFiles === 1) {
        <span class="flagged-files-summary__text" [dataSelector]="dataSelector + '-text'">
          1 file was flagged and requires your attention
        </span>
      } @else {
        <span class="flagged-files-summary__text" [dataSelector]="dataSelector + '-text'">
          {{ flaggedSummary.totalFiles }} files across {{ flaggedSummary.uniqueRequestItems }} request{{ flaggedSummary.uniqueRequestItems === 1 ? '' : 's' }} were flagged and require your attention
        </span>
      }
    </div>

    @if (!isMobileMode()){
      <div class="flagged-files-summary__list" [dataSelector]="dataSelector + '-list'">
        @for (file of flaggedSummary.displayFiles; track file.id) {
          <div
            class="flagged-files-summary__file-item"
            [class.flagged-files-summary__file-item--clickable]="file.requestItemId"
            [dataSelector]="dataSelector + '-file-' + file.id"
            (click)="selectRequestItem(file)">
            <span class="flagged-files-summary__file-name">{{ file.name }}</span>
            <span class="flagged-files-summary__request-item">({{ file.requestItemName }})</span>
          </div>
        }

        @if (flaggedSummary.remainingCount > 0) {
          <div class="flagged-files-summary__more" [dataSelector]="dataSelector + '-more'">
            + {{ flaggedSummary.remainingCount }} more
          </div>
        }
      </div>
    }
  </div>
}
